<template>
    <div class="foodSafety">
        <div class="header">管理人员</div>
        <div class="nav">
            <div class="nav_word">市场管理人员</div>
            <div><img src="../assets/images/people.png" alt="" class="nav_png" /></div>
        </div>
        <div class="price">
            <div class="list">
                <div class="box" v-for="(item, index) in list" :key="index" @click="Jump(item.id)">
                    <div class="top">
                        <img :src="item.headImg" alt="" class="list_png" />
                        <div class="job">{{ item.job }}</div>
                        <!-- //职位 -->
                    </div>

                    <div class="word">
                        <div class="tit">{{ item.name }}</div>
                        <div class="list_word">
                            <img src="../assets/images/phon.png" alt="" class="list_card">
                            {{ item.mobile }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="back" @click="back">
            <img src="../assets/images/back.png" alt="" class="back_png">
            <span class="back_word">返回</span>
        </div>
    </div>
</template>
<script>
import { employeeList } from "@/api/home"
export default {
    data() {
        return {
            tenantId:'',
            list: [],
        }
    },
    created() {
        this.tenantId = this.$route.params.tenantId
    },
    mounted() {
        this.getAll()
    },
    methods: {
        getAll() {
            employeeList({
                tenantId: this.tenantId
            }).then(res => {
                this.list = res.data
               

            }).catch(err => {
                //  alert(err)
            })

        },
        back() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less" scoped>
.foodSafety {

    .header {
        height: 0.9rem;
        line-height: 0.9rem;
        font-size: 0.32rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 400;
        color: #3E3E3E;
        background: #FFFFFF;
        opacity: 1;
    }

    .nav {
        height: 3.32rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.38rem;
        background: linear-gradient(180deg, rgba(34, 110, 217, 0.22) 0%, #FFFFFF 100%);

        .nav_word {
            height: 0.5rem;
            font-size: 0.4rem;
            font-weight: bold;
            color: #3D3D3D;
            line-height: 0.5rem;
            letter-spacing: 0.01rem;
            margin-top: 1rem;
        }

        .nav_png {
            width: 2rem;
            height: 2rem;
            margin-top: 0.2rem;
            // float: right;
            // margin: 0.3rem 0.46rem 0 0;
        }
    }

    .price {
        margin-top: -1.5rem;
        //height:7.5rem;
        // background: #FFFFFF;
        // border-radius: 0.32rem 0.32rem 0rem 0rem;
        opacity: 1;
        box-sizing: border-box;
        padding: 0 0.44rem;

        .list {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .box {
                width: 4.4rem;
                height: 5.08rem;
                position: relative;
                margin-top: 0.28rem;
                border-radius: 0.2rem;
                background: #F7F8FA;

                .top {
                    position: relative;

                    .list_png {
                        width: 100%;
                        height: 3.36rem;
                        // position: absolute;
                        // left: 0;
                        // top: 0;
                        // z-index: 1;
                    }

                    .job {
                        position: absolute;
                        height: 0.44rem;
                        background: #DFE7F7;
                        border-radius: 0.5rem;
                        font-size: 0.24rem;
                        font-weight: 400;
                        color: #014FEA;
                        padding: 0.06rem 0.22rem;
                        top: 0.16rem;
                        left: 0.16rem;
                    }
                }


                .word {
                    position: absolute;
                    left: 0.24rem;
                    bottom: 0.38rem;
                    z-index: 1;
                    text-align: left;

                    .tit {
                        font-size: 0.36rem;
                        font-weight: bold;
                        color: #3D3D3D;
                        height: 0.8rem;
                        line-height: 0.8rem;
                    }

                    .list_word {
                        font-size: 0.28rem;
                        font-weight: 400;
                        color: #6E6E6E;

                        .list_card {
                            width: 0.32rem;
                            height: 0.32rem;
                            vertical-align: middle;
                            margin: -0.06rem 0.1rem 0 0;
                        }
                    }
                }
            }
        }

    }

    .back {
        width: 1.74rem;
        height: 0.92rem;
        line-height: 0.92rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.12rem 0.26rem -0.02rem #DCDCDC;
        border-radius: 0.2rem;
        position: fixed;
        bottom: 0.68rem;
        left: 0.24rem;
        z-index: 99;
        .back_png {
            width: 0.3rem;
            height: 0.44rem;
            vertical-align: middle;
            margin-top: -0.1rem;
        }

        .back_word {
            font-size: 0.32rem;
            font-weight: 400;
            color: #3D3D3D;
            margin-left: 0.1rem;
        }
    }
}
</style>